import vuexStore from "@/store/customSaveStore";
import { transferingLegalRecommendation } from "../../recommendation/legal/store";

export const datasubjectTransfering = vuexStore({
  namespaced: true,
  path: "/datasubject-transfering",
  state: {
    editedDatasubject: null,
    editedDatasubjectTransfering: null,
    selectedMethods: [],
    selectedPreventions: [],
    selectedLegals: [],
    ...transferingLegalRecommendation.state,
  },
  getters: {
    editedDatasubject: (state) => state.editedDatasubject,
    editedDatasubjectTransfering: (state) => state.editedDatasubjectTransfering,
    selectedMethods: (state) => state.selectedMethods,
    selectedPreventions: (state) => state.selectedPreventions,
    selectedLegals: (state) => state.selectedLegals,
    ...transferingLegalRecommendation.getters,
  },
  mutations: {
    editedDatasubject: (state, value) => {
      state.editedDatasubject = value;
    },
    editedDatasubjectTransfering: (state, value) => {
      state.editedDatasubjectTransfering = value;
      if (value) {
        state.selectedMethods = [...value.methods];
        state.selectedPreventions = [...value.preventions];
        state.selectedLegals = [
          ...value.legals.map((i) => ({
            ...i,
            legitimateInterestLocalized: i.legitimateInterest,
            legitimateInterest: i.legitimateInterest ? i.legitimateInterest["tr"] : "", //TODO root stateden language gelmeli
          })),
        ];
      } else {
        state.selectedMethods = [];
        state.selectedPreventions = [];
        state.selectedLegals = [];
      }
    },
    ...transferingLegalRecommendation.mutations,

    addMethod: (state, value) => {
      if (Array.isArray(value)) {
        state.selectedMethods = [...value];
      } else {
        state.selectedMethods.push(value);
      }
    },
    removeMethod: (state, value) => (state.selectedMethods = [...state.selectedMethods.filter((i) => i._id != value._id)]),

    addPrevention: (state, value) => state.selectedPreventions.push(...(Array.isArray(value) ? value : [value])),
    removePrevention: (state, value) => (state.selectedPreventions = [...state.selectedPreventions.filter((i) => i._id != value._id)]),

    addLegal: (state, value) => {
      if (!state.selectedLegals.find((i) => i.legalReason.libraryItem._id == value.legalReason.libraryItem._id && i.purpose.libraryItem._id == value.purpose.libraryItem._id)) {
        state.selectedLegals.push(value);
      }
    },
    removeLegal: (state, value) => {
      state.selectedLegals = [
        ...state.selectedLegals.filter((i) => !(i.legalReason.libraryItem._id == value.legalReason.libraryItem._id && i.purpose.libraryItem._id == value.purpose.libraryItem._id)),
      ];
    },
    updateLegitimateInterest: (state, { legal, legitimateInterest }) => {
      const founded = state.selectedLegals.find((i) => i.legalReason._id == legal.legalReason._id);
      if (founded) {
        founded.legitimateInterest = legitimateInterest;
        founded.legitimateInterestLocalized = {
          tr: legitimateInterest,
          en: legitimateInterest,
          fr: legitimateInterest,
          de: legitimateInterest,
        };
      }
    },
  },

  actions: {
    ...transferingLegalRecommendation.actions,
  },
});
